import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AnimatedSection } from './AnimatedSection';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-charcoal/10 last:border-0" data-id="element-93">
      <button className="w-full py-6 flex justify-between items-center text-left focus:outline-none focus:ring-2 focus:ring-sage/50 focus:ring-offset-2 rounded-lg" onClick={onClick} aria-expanded={isOpen} data-id="element-94">
        <span className="text-lg font-semibold text-charcoal pr-8 font-heading" data-id="element-95">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-96">
          <ChevronDownIcon className="w-5 h-5 text-sage flex-shrink-0" data-id="element-97" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-98">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-99">
            <p className="pb-6 text-charcoal/70 leading-relaxed" data-id="element-100">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Necesito equipo especial?',
    answer: 'No, solo tu cuerpo y a veces un poco de agua fría. Las técnicas están diseñadas para que puedas aplicarlas en cualquier lugar, sin necesidad de herramientas adicionales.'
  }, {
    question: '¿Es seguro?',
    answer: 'Sí, son técnicas fisiológicas naturales basadas en la respuesta del nervio vago. No hay efectos secundarios y son completamente seguras para la mayoría de las personas.'
  }, {
    question: '¿Cuánto tarda en hacer efecto?',
    answer: 'El protocolo está diseñado para dar alivio entre los 60 y 120 segundos. La mayoría de las personas sienten un cambio notable en su nivel de ansiedad casi inmediatamente.'
  }];
  return <AnimatedSection className="py-16 md:py-24 px-6 max-w-3xl mx-auto" data-id="element-101">
      <div className="text-center mb-12" data-id="element-102">
        <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-103">
          Preguntas Frecuentes
        </h2>
      </div>

      <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-charcoal/5" data-id="element-104">
        {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-105" />)}
      </div>
    </AnimatedSection>;
}